export interface FileReport {
  id: number
  created_at: string
  error: string
  file_url: string | null
  name: string
  status: string
}

export const ReportType = {
  logistics: 'logistics',
  cards: 'cards',
  autoMonthly: 'auto_monthly',
  outlets: 'outlets',
  revival: 'revival',
  acquiredClients: 'acquired_clients',
} as const
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ReportType = (typeof ReportType)[keyof typeof ReportType]
